<script lang="ts">
    import type {CssSize} from 'shared/ui-widgets/types';
    import {exists} from 'shared/utils/custom-utils';

    export let gap: CssSize = '12px';
    export let additionalClasses = '';
    export let backgroundImageUrl: string | null = null;
</script>

<div class="erp-heading-bar {additionalClasses}"
     class:with-background-image="{exists(backgroundImageUrl)}"
     style:--background-image-url={`url("${backgroundImageUrl}")`}
     style:--gap="{gap}">

    <div class="heading-container">
        <slot/>
    </div>

    {#if exists($$slots['additional-content'])}
        <div class="additional-content-container">
            <slot name="additional-content"/>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .erp-heading-bar {
        width: 100%;
        display: flex;
        position: relative;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid @themed-border-default;
        padding: @spacing-xxl @main-padding-horizontal;
        background-image: var(--background-image-url);
        background-size: cover;
        gap: @spacing-ml;

        .heading-container {
            display: flex;
            align-items: center;
            gap: var(--gap);
        }

        .additional-content-container {
            display: flex;
            align-items: center;
            gap: var(--gap);
        }
    }
</style>